import Runes0 from '@/public/assets/images/runes/10.png'
import Runes1 from '@/public/assets/images/runes/11.png'
import Runes2 from '@/public/assets/images/runes/12.png'
import Runes3 from '@/public/assets/images/runes/13.png'
import Runes4 from '@/public/assets/images/runes/14.png'
import Runes5 from '@/public/assets/images/runes/15.png'
import Runes6 from '@/public/assets/images/runes/16.png'
import Runes7 from '@/public/assets/images/runes/17.png'

export const RUNSES = [
  {
    src: Runes0,
    shadow: '',
    alt: 'Runes 0',
  },
  {
    src: Runes1,
    shadow: '0px 0px ${var} 0px rgba(255, 72, 0) inset',
    alt: 'Runes 1',
  },
  {
    src: Runes2,
    shadow: '0px 0px ${var} 0px rgba(244, 4, 255) inset',
    alt: 'Runes 2',
  },
  {
    src: Runes3,
    shadow: '0px 0px ${var} 0px rgba(255, 160, 35) inset',
    alt: 'Runes 3',
  },
  {
    src: Runes4,
    shadow: '0px 0px ${var} 0px rgba(2, 154, 251) inset',
    alt: 'Runes 4',
  },
  {
    src: Runes5,
    shadow: '0px 0px ${var} 0px rgba(9, 247, 30) inset',
    alt: 'Runes 5',
  },
  {
    src: Runes6,
    shadow: '0px 0px ${var} 0px rgba(222, 1, 241) inset',
    alt: 'Runes 6',
  },
  {
    src: Runes7,
    shadow: '0px 0px ${var} 0px rgba(255, 94, 62) inset',
    alt: 'Runes 7',
  },
]
